export default "<div data-name=\"ecEnrollVirtualTrainingProgram\">\n\t<ec-enroll-virtual-training-program></ec-enroll-virtual-training-program>\n</div>\n";